import React, { useState } from "react";
import {
  Box,
  Button,
  Stepper,
  Step,
  StepLabel, 
} from "@mui/material";
 
import GoalSelectionStep from "../components/organization-steps/GoalSelectionStep";
import OrganizationSelectionStep from "../components/organization-steps/OrganizationSelectionStep";
const steps = ["Organization", "Goal"];

const OrganizationSetup = () => {
  const [activeStep, setActiveStep] = useState(0); 

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };


  return (
    <Box sx={{ width: "100%", maxWidth: 800, margin: "auto", my: 5, }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box sx={{ mt: 5 }}>
        {activeStep === 0 && (
          <OrganizationSelectionStep onNext={handleNext}  />
        )}

        {activeStep === 1 && (
          <GoalSelectionStep onNext={handleNext}
  onBack={handleBack} />
        )}
      </Box>

      {/* <Box sx={{ display: "flex", justifyContent: "space-between", mt: 5 }}>
        <Button disabled={activeStep === 0} onClick={handleBack}  sx={{background:'#fff', color:'#595959', border:'1px solid #b8b8b8', textTransform:'capitalize', fontSize:'14px',}}>
          Back
        </Button>
        <Button onClick={handleNext} sx={{background:'#0B57D0', color:'#fff', textTransform:'capitalize', fontSize:'14px', px:3}}>
          {activeStep === steps.length - 1 ? "Start Now" : "Next"}
        </Button>
      </Box> */}
    </Box>
  );
}
export default OrganizationSetup

 


